const stripePublicKeys = {
    'dev': {
        'truple': 'pk_test_51RUX6JR5VAWx8HgpN4D1mbTY3c2zzaV7el9iOHgwBQjzMUfOp9m9J9A2IGq2FNBixPWub5CeRo768egyzzLRZwCs00EqsjEoej',
        'screenkin': 'pk_test_51Rb986DIlyfw3PN5qCQKE3Qfp9ihYVScmcOWzqFmnGxgQ7ecmL5WJvJabk0lPEGQXNI6fzm6tqjYOAzqnPUXbWGO00IxJdFZyr',
        'bestaccountability': '', //TODO: update with best accountability key
    },
    'prod': {
        'truple': 'pk_live_hWoYKzNo6joydLSVnB2RQ5Ru',
        'screenkin': 'pk_live_51Rb980DFjKMCvfzCmdvzBuvcRZP8vBU2OCzOU81A2LApYdtt8uAcHJew2gsE9HGx7B1wA5zg77hZnxUvPUhZh3u4005dDmjACd',
        'bestaccountability': '', //TODO: update with best accountability key
    }
}

class StripeKeyHelper {
    getStripeKey(product) {
        let val = null
        if(product) {
            val = stripePublicKeys[process.env.VUE_APP_ENV][product]
        } else {
            val = stripePublicKeys[process.env.VUE_APP_ENV][process.env.VUE_APP_PRODUCT]
        }
        if(!val) {
            throw new Error(`Stripe key not found for ${process.env.VUE_APP_ENV} ${product} ${process.env.VUE_APP_PRODUCT}`);
        }
        return val
    }
}

export default (new StripeKeyHelper())